import { FC, Fragment } from 'react';
import Tooltip from 'components/ui/Tooltip/Tooltip';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbsDown, faThumbsUp } from '@fortawesome/free-regular-svg-icons';
import withErrorBoundary from '../../withErrorBoundary';

interface GoogleHotelReviewsProps {
  res?: any;
}

export const GoogleHotelReviews: FC<GoogleHotelReviewsProps> = ({ res }) => {
  const { t } = useTranslation();
  return (
    <div>
      {!!res?.serpResults?.serpHotel && (
        <Fragment>
          {' '}
          <div className="h-ratings-wr">
            <div className="h-ratings">
              <div className="h-ratings-number">{res.serpResults.serpHotel.overallRating}</div>
              <div className="text-light">
                {res.serpResults.serpHotel.reviews} {t('hotel.reviews')}
              </div>
            </div>
            <div className="h-ratings-list">
              {res.serpResults.serpHotel.ratings?.map((rat: any, index: number) => (
                <div key={index} className="h-ratings-row-wr">
                  <div className="h-ratings-star text-sm">
                    {rat.stars} {t('sort.star')}
                  </div>

                  <div className="h-ratings-row">
                    <div
                      className="h-ratings-row-yellow"
                      style={{
                        width: (rat.count / res.serpResults.serpHotel.reviews) * 100 + '%',
                      }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="mt-10 h-ratings-breakdown">
            {res.serpResults.serpHotel.reviewsBreakdown
              ?.sort(
                (a: any, b: any) =>
                  b.positive / b.totalMentioned -
                  b.negative / b.totalMentioned -
                  (a.positive / a.totalMentioned - a.negative / a.totalMentioned)
              )
              .map((rew: any, index: number) => (
                <div className="h-ratings-breakdown-item" key={index}>
                  <Tooltip
                    position="top"
                    content={[
                      { val: rew.positive, text: t('hotel.positive') },
                      { val: rew.neutral, text: t('hotel.neutral') },
                      { val: rew.negative, text: t('hotel.negative') },
                    ]
                      .filter((f) => f.val)
                      .map((f) => f.text + ': ' + f.val)
                      .join(', ')}
                  >
                    <span>
                      {rew.positive / rew.totalMentioned - rew.negative / rew.totalMentioned >
                        0.42 && (
                        <FontAwesomeIcon icon={faThumbsUp} color="green" className="mr-5" />
                      )}
                      {rew.positive / rew.totalMentioned - rew.negative / rew.totalMentioned <
                        -0.42 && (
                        <FontAwesomeIcon icon={faThumbsDown} color="red" className="mr-5" />
                      )}
                      {rew.name} <span className="text-light">({rew.totalMentioned}) </span>
                    </span>
                  </Tooltip>
                </div>
              ))}
          </div>
        </Fragment>
      )}
    </div>
  );
};

export default withErrorBoundary(GoogleHotelReviews, 'GoogleHotelReviews');
